module.exports = __webpack_public_path__ + "img/icon-circle-exclamation-white.a03908f1.svg";